// context/ModuleContext.tsx
import React, { createContext, useContext, useMemo } from "react";
import { useOrganization } from "./organization.context";

type ModuleContextType = {
  modules: any[];
  enabledModules: any[];
  isEnabled: (moduleName: string) => boolean;
};

const ModuleContext = createContext<ModuleContextType>({} as ModuleContextType);

export const ModuleProvider = ({ children }: { children: React.ReactNode }) => {
  const { activeOrg } = useOrganization();

  const modules = useMemo(() => activeOrg?.modules || [], [activeOrg]);

  const enabledModules = useMemo(
    () => activeOrg?.modules?.filter((e) => e.isEnabled) || [],
    [activeOrg]
  );

  const isEnabled = (moduleName: string) => {
    return enabledModules.some((e) => e.moduleCode === moduleName);
  };

  return (
    <ModuleContext.Provider
      value={{
        modules,
        enabledModules,
        isEnabled,
      }}
    >
      {children}
    </ModuleContext.Provider>
  );
};

export const useModules = () => useContext(ModuleContext);
